export const seoDefaultTab = 'complex'
export const severDefaultTab = 'all'
export const defaultTabName = '综合'
export const allDefaultSort = 'hot'
export const pageSize = 30 // 目前接口有限制，最大为 30
export const sortTypeList = [
  { name: '最热推荐', value: allDefaultSort },
  { name: '最新发布', value: 'release' },
]

export type seoTab = 'complex' | 'video' | 'picture' | 'qa'
export type serverTab = 'all' | 'video' | 'post' | 'wenda'

const seoTabs: seoTab[] = [seoDefaultTab, 'video', 'picture', 'qa']
const serverTabs: serverTab[] = [severDefaultTab, 'video', 'post', 'wenda']
const tabNames = [defaultTabName, '视频', '图文', '问答']

const seoServerMap = new Map(
  seoTabs.map((item, index) => [item, serverTabs[index]])
)

const nameSeoMap = new Map(
  tabNames.map((item, index) => [item, seoTabs[index]])
)

const seoNameMap = new Map(
  seoTabs.map((item, index) => [item, tabNames[index]])
)

export function getServerTypeBySeo(tab: string): serverTab {
  return seoServerMap.get(tab as seoTab) || severDefaultTab
}

export function getSeoTypeByName(name: string): seoTab {
  return nameSeoMap.get(name) || seoDefaultTab
}

export function getTabNameBySeo(tab: string): string {
  return seoNameMap.get(tab as seoTab) || defaultTabName
}
